module.exports = __webpack_public_path__ + "static/media/koryu_00001p.0a39ae9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_00001p.png
// module id = 208
// module chunks = 0